import {
    UPDATE_LANG
} from "../constants/appConstants";

/*
 * action creators
 */
const updateLang = (lang) => {
    const  langTxt = (lang === "")? 'en' : lang;
    const  langUrl = (lang === "")? '' : '/' + lang;
    return { type: UPDATE_LANG, payload: {langTxt, langUrl} }
};

export const update = (data) => {
    return (dispatch) => {
        return dispatch(updateLang(data));
    };
}